module.exports = __webpack_public_path__ + "source/img/copy.6371fa72.svg";